<template>
  <div class="doc-tip-com">
    <div class="message-on" v-if="/^替代.*/g.test(message)">{{message}}</div>
    <div class="message-off" v-else-if="message.includes('废止') || message.includes('失效') || /^被.*替代$/g.test(message)">{{message}}</div>
  </div>
</template>

<script>
export default {
  props: ['message'],
  methods: {
  },
  mounted () {
  }
}
</script>

<style lang="scss">
.doc-tip-com {
  background: rgba(255, 255, 255, 0.3);
  .message-off {
    right: 40px;
    top: 34px;
    padding: 2px 0px;
    color: #F56C6C;
    font-weight: bold;
    font-size: 12px;
    opacity: 0.8;
  }
  .message-on {
    right: 40px;
    top: 34px;
    padding: 2px 0px;
    color: #67C23A;
    font-weight: bold;
    font-size: 12px;
    opacity: 0.8;
  }
}
</style>
